'use strict';

angular.module('ClinicApp').directive('removeButton', function($document) {
  return {
    scope: {
      onRemove: '&removeButton',
    },
    templateUrl: '/views/directives/_remove-button.html',
    link: function($scope, el) {
      el.find('a').on('click', function(e) {
        e.stopPropagation();

        // Listen clicking on all except of the remove button.
        $document.not(el.find('.btn-danger')).on('click', function() {
          $scope.$apply(function() {
            $scope.showRemoveButton = false;
          });
        });
      });

      $scope.remove = function() {
        return $scope.onRemove()['finally'](function() {
          $scope.showRemoveButton = false;
        });
      };
    },
  };
});
